<template>
  <div id="tip_alertModal" class="tip_alertModal">
    <div
      class="dialog-content"
      :class="{ show: show }"
      @click.prevent.stop
      @touchmove.prevent
    >
      <div class="dialog-main-box">
        <p class="dialog-title-p">{{ title }}</p>
        <p class="dialog-contant-p">{{ content }}</p>
        <div class="dialog-btn-row">
          <p class="btn-cancel" @click="cancel" v-if="cancelBtn">
            {{ left }}
          </p>
          <p class="btn-confirm" @click="confirm">
            {{ right }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: true, // 通过这个属性，控制是否移除dom元素
      title: '', // 顶部标题
      content: '', // 内容
      left: '',
      right: '',
      cancelBtn: false // 取消按钮
    };
  },
  methods: {
    confirm() {
      // 确定
      this.a_confirm && this.a_confirm();
      this.show = false;
      // 删除判断增加的window属性
      delete window.alertIsShow;
    },
    cancel() {
      // 取消
      this.a_cancel && this.a_cancel();
      this.show = false;
      // 删除判断增加的window属性
      delete window.alertIsShow;
    }
  },
  watch: {
    show(cur, old) {
      // 通过监控data里的show属性  弹框有三个事件（右上角取消  确定按钮  取消按钮）
      // 每个事件写了 this.show = false
      // 当弹框出现的时候 点击任何一个事件  都会触发这里的监控事件  将页面上的弹框Dom移除
      if (cur === false) {
        let tip_alert = document.getElementById('tip_alertModal');
        tip_alert.parentNode.removeChild(tip_alert);
      }
    }
  }
};
</script>

<style scoped lang="less">
.tip_alertModal {
  .dialog-content {
    z-index: 20001;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    transition: all 0.26s;
    visibility: hidden;
    background-color: fadeout(#222, 70%);
    opacity: 0;
    .dialog-main-box {
      position: absolute;
      left: 50%;
      top: 50%;
      width: var(--f7-dialog-width);
      // width: 90%;
      padding: var(--f7-dialog-inner-padding);
      font-size: 0.14rem;
      line-height: 0.28rem;
      color: #222;
      transition: all 0.26s;
      visibility: hidden;
      transform: translate(-50%, -50%) scale(0.5);
      background-color: #fff;
      border-radius: 0.1rem;
      .dialog-btn-row {
        display: flex;
        justify-content: space-around;
        margin-top: 0.1rem;
        margin-bottom: 0.05rem;
        p {
          flex: 1;
          text-align: center;
          line-height: 0.46rem;
          font-size: 0.16rem;
          letter-spacing: -0.02rem;
          color: var(--maincolor);
        }
      }
    }
    .dialog-title-p {
      font-size: 0.16rem;
      text-align: center;
      margin-bottom: 0.08rem;
    }
    .dialog-contant-p {
      font-size: 0.15rem;
      line-height: 0.18rem;
    }
    &.show {
      visibility: visible;
      opacity: 1;
      .dialog-main-box {
        visibility: visible;
        transform: translate(-50%, -50%) scale(1);
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog/cErrorDialog.vue